<template lang="pug">
    .chart-container.pageview-chart(v-loading="loading")
        //- template(v-if="runningJobs.length")
        //-     .job
        //-         el-progress(
        //-             :percentage="Math.round(runningJobs[0].percentage * 100) / 100"
        //-             :width="50"
        //-             :show-text="false"
        //-         )
        //-         .summary(v-if="runningJobs[0].percentage && runningJobs[0].current > 0")
        //-             small {{ runningJobs[0].current }} / {{ runningJobs[0].total }}
        //-             small {{ runningJobs[0].percentage.toFixed(2) }}%
        el-form.filters(ref="form" label-width="70px" size="mini" :inline="true")
            el-form-item(:label="$t('Domain')")
                el-select(
                    placeholder=""
                    filterable
                    v-model="domain"
                    autocomplete="no-fill"
                    :disabled="domainOptions.length <= 1"
                )
                    el-option(v-for="domain in domainOptions" :key="domain.label" :label="domain.label" :value="domain.label")
            el-form-item(:label="$t('Daterange')")
                //- el-date-picker(
                //-     v-model="daterange"
                //-     :class="{ filled: daterange[0] || daterange[1] }"
                //-     type="daterange"
                //-     range-separator=" - "
                //-     size="mini"
                //-     :format="$t('yyyy-MM-dd')"
                //-     prefix-icon="far el-icon-fa-calendar-alt"
                //-     :unlink-panels="true"
                //-     :picker-options="{ firstDayOfWeek: 1 }"
                //- )
                el-date-picker(
                    v-model="date"
                    :type="datepickerType"
                    size="mini"
                    :format="datepickerFormat"
                    prefix-icon="far el-icon-fa-calendar-alt"
                    :unlink-panels="true"
                    :picker-options="{ firstDayOfWeek:1, disabledDate }"
                )
            el-form-item(:label="$t('Period')")
                el-select(placeholder="" filterable v-model="period" autocomplete="no-fill")
                    el-option(v-for="period in periodOptions" :key="period.key" :label="period.label" :value="period.key")
        .pagination-wrap
            el-button.prev(
                v-if="!loading"
                size="mini"
                type="primary"
                icon="el-icon-arrow-left"
                circle
                @click="prev"
                style="left: -15px"
            )
            el-button.next(
                v-if="!loading"
                size="mini"
                type="primary"
                icon="el-icon-arrow-right"
                circle
                @click="next"
                :disabled="isNextDisabled"
                style="right: -15px"
            )
            //- :height="widget.settings.height"
            //- line-chart.chart(
            //-     ref="chart"
            //-     :chart-data="datacollection"
            //-     :options="chartOptions"
            //-     :height="widget.settings.height"
            //- )
            line-chart-extended.chart(
                ref="chart"
                :chart-data="datacollection"
                :options="chartOptions"
                :height="widget.settings.height"
            )
        //- button(@click="generate") Randomize
        .legend
            ul.no-style-list
                li.all-visitors
                    el-button(
                        size="mini"
                        @click.exact="toggleDatasets(['all-visitors'])"
                        @click.ctrl.exact="toggleDatasets(['all-visitors'], 'ctrl')"
                    )
                        span.color(:style="getLegendStyle('all-visitors')")
                        span.label(:class="{ 'strike-through': disabledDatasets.includes('all-visitors') }")
                            | {{ $t('Unique Visitors') }}
                li.all-views
                    el-button(
                        size="mini"
                        @click.exact="toggleDatasets(['all-pageviews'])"
                        @click.ctrl.exact="toggleDatasets(['all-pageviews'], 'ctrl')"
                    )
                        span.color(:style="getLegendStyle('all-pageviews')")
                        span.label(:class="{ 'strike-through': disabledDatasets.includes('all-pageviews') }")
                            | {{ $t('Siteviews') }}
                li.force-update(style="margin-right: 10px; font-size: 1.2rem; line-height: 1; position: relative; top: 3px;")
                    a.force-update-icon(href="#" @click.prevent="forceUpdate")
                        i.el-icon-fa-sync-alt.fas
                //- li(v-if="runningJobs.length || pendingJobs.length")
                //-     .spinner
                //- li.force-update(v-else style="margin-right: 10px; font-size: 1.2rem; line-height: 1; position: relative; top: 3px;")
                //-     a.force-update-icon(href="#" @click.prevent="forceUpdate")
                //-         i.el-icon-fa-sync-alt.fas
            template(v-if="campaigns.length && enabledExtensions.includes('marketing')")
                hr
                .campaigns
                    .left
                        el-button-group
                            //- :icon="campaignVisitorsVisible ? 'el-icon-fa-eye-slash fas' : 'el-icon-fa-eye fas'"
                            el-button(
                                size="mini"
                                :icon="campaignVisitorsVisible ? '' : 'el-icon-fa-eye-slash fas'"
                                :type="campaignVisitorsVisible ? 'default' : 'info'"
                                @click="toggleCampaignVisitors"
                            )
                                //- template(v-if="campaignVisitorsVisible") {{ $t('Hide Visitors') }}
                                //- template(v-else) {{ $t('Show Visitors') }}
                                | {{ $t('Unique Visitors') }}

                            //- :icon="campaignViewsVisible ? 'el-icon-fa-eye-slash fas' : 'el-icon-fa-eye fas'"
                            el-button(
                                size="mini"
                                :icon="campaignViewsVisible ? '' : 'el-icon-fa-eye-slash fas'"
                                :type="campaignViewsVisible ? 'define' : 'info'"
                                @click="toggleCampaignViews"
                            )
                                //- template(v-if="campaignViewsVisible") {{ $t('Hide Siteviews') }}
                                //- template(v-else) {{ $t('Show Siteviews') }}
                                | {{ $t('Siteviews') }}
                    .right
                        ul.no-style-list
                            li.campaign(v-for="campaign in campaigns")
                                el-button(
                                    size="mini"
                                    @click.exact="toggleDatasets([`${campaign.key}:visitors`, `${campaign.key}:views`])"
                                    @click.ctrl.exact="toggleDatasets([`${campaign.key}:visitors`, `${campaign.key}:views`], 'ctrl')"
                                )
                                    span.color(
                                        :class="{ disabled: campaignVisitorsVisible !== true }"
                                        :style="getLegendStyle(`${campaign.key}:visitors`, campaignVisitorsVisible !== true)"
                                    )
                                    span.secondary-color(
                                        :class="{ disabled: campaignViewsVisible !== true }"
                                        :style="getLegendStyle(`${campaign.key}:views`, campaignViewsVisible !== true)"
                                    )
                                    span.label(:class="{ 'strike-through': disabledDatasets.includes(`${campaign.key}:visitors`) || disabledDatasets.includes(`${campaign.key}:views`)}")
                                        | {{ campaign.name }}
</template>

<script>
import SiteViewsChart from '@/views/cms/Dashboard/widgets/statistics/SiteViewsChart'
import StatisticsApi from '@/store/api/statistics';

import { adminClient as apolloClient } from '@/store/apollo';

import endOfDay from 'date-fns/endOfDay'
import startOfDay from 'date-fns/startOfDay';

import getUnixTime from 'date-fns/getUnixTime'
import _ from 'lodash';

export default {
    name: 'PageViewsChart',
    extends: SiteViewsChart,
    props: {
        page: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            logKeys: ['summarize-page-view-statistics'],
        }
    },
    // computed: {
    //     jobs() {
    //         return this.allJobs.filter(job => job.type === 'summarize:page-view-statistics')
    //     },
    // },
    methods: {
        async forceUpdate() {
            this.loading = true;

            await apolloClient.clearStore()
            StatisticsApi.generatePageviewStatistics({ cms: this.activeCms.id })
                .then(() => {
                    this.$notify.success({
                        title: this.$t('The summary will be processed asynchronously'),
                        message: this.$t('You will be notified once the summary is completed'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        refetch(loading = true) {
            this.loading = loading;

            let filters = {
                cms: this.activeCms.id,
                pages: [parseInt(this.page.id)],
                domain: _.get(this.widget, 'settings.domain') || _.get(this.domainOptions, '0.label'),
                period: _.get(this.widget, 'settings.period') || 'hour',
                from: _.get(this.widget, 'settings.start') || getUnixTime(startOfDay(new Date)),
                to: _.get(this.widget, 'settings.end') || getUnixTime(endOfDay(new Date)),
            };

            StatisticsApi.fetchPageviewStatistics(filters)
                .then(data => {
                    this.setWidgetValue({
                        widget: this.widget,
                        key: 'data',
                        value: data
                    });

                    this.$nextTick(() => {
                        this.generate();
                        if (this.$refs.chart) {
                            this.$refs.chart.renderChart(this.datacollection, this.chartOptions)
                            setTimeout(() => this.chartOptions.animation.duration = 0, 1000);
                        }
                    })
                })
                .finally(() => {
                    this.loading = false
                })

        },
        setWidgetValue(data) {
            this.$emit('update-widget-value', data)
        }
    }
}
</script>
